import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { GET_ACCESS_TOKEN } from "../actions";

export const authLoadingSelector = createLoadingSelector([GET_ACCESS_TOKEN]);
export const authErrorSelector = createErrorSelector([GET_ACCESS_TOKEN]);

export const isAuthenticatedSelector = (state: any) => state.authentication.isAuthenticated;

export const isUnauthorisedSelector = (state: any) => state.authentication.unauthorised;